module.exports = __webpack_public_path__ + "static/media/Folder.17978ea1.svg";